/**
 * Countries whose tax requirement is an integration form (the US withholding
 * certificate). Kept in sync with the backend `TAX_INTEGRATION_COUNTRIES`.
 *
 * Puerto Rico (PR) is a US territory whose residents are US persons for federal
 * tax purposes, so it uses the same certificate flow as the US (NBP-1504).
 */
export const TAX_INTEGRATION_COUNTRIES: readonly string[] = ["US", "PR"];

/**
 * Whether a participant in the given country must complete a tax form, and
 * therefore whether the tax tab and tax pages should be available to them.
 */
export const isTaxRequiredForCountry = (
  countryCode: string | null | undefined
): boolean =>
  TAX_INTEGRATION_COUNTRIES.includes((countryCode ?? "").toUpperCase());
